<template>
    <div class="product">
        <div class="product-video">
					<slot name="video" />
        </div>
        <div class="title">{{title}}</div>        
        <div class="content">

        <slot />
        <ul class="key-features">
            <slot name="key-features" />
        </ul>
        <a-cta :to="ctaLink" :data-iv-cta="id" sidePadding="70px">Learn More</a-cta>
    </div>
  </div>
</template>
<script>
import ACta from '@/components/a-cta'
export default {
    components: {
        ACta
    },
    data(){
        return {
        }
    },
		props: {
			title: String,
			ctaLink: String,
            id: String,
		}
}
</script>
<style lang="scss" scoped>
.product {
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin: 0px 100px;
    @media (max-width: 1200px) {
        margin: 0px;
    }
    @media (max-width: 950px) {
        grid-template-columns: 1fr;
        grid-template-rows: auto auto auto;
    }
}
.product-video {
    position: relative;
    width: 100%;
    grid-column: 1 / 2;
    grid-row: 1 / 3;
    @media (max-width: 950px) {
        grid-column: 1 / 3;
        grid-row: 2 / 3;
    }
}
.content {
    margin-left: 50px;
    max-width: 700px;
    @media (max-width: 950px) {
        margin-left: 0;
        grid-row: 3 / 4;
    }
}
.title {
    margin-left: 50px;
    max-width: 700px;
    font-weight: bold;
    font-size: 2.5em;
    color: $navy;
    @media (max-width: 950px) {
        margin-left: 0px;
        margin-bottom: 20px;
        grid-column: 1 / 3;
        grid-row: 1 / 2;
    }
}
.key-features {
    padding-left: 15px;
    margin-bottom: 40px;
}
.key-features li {
    list-style: none;
    position: relative;
    margin-bottom: 10px;
    margin-left: 10px;
    font-size: 1em;
    .bullet {
        position: absolute;
        left: -25px;
        top: 0px;
    }
}

</style>
